export default "__VITE_ASSET__Cg8jw$xK__"